export const LOGIN_IMAGES = {
    PARROT_LOGO: '/assets/images/Frame.png',
};
